import React, { useRef, useState } from "react";
import Swiper, { SwipeRef } from "react-tiga-swiper";
import "react-tiga-swiper/dist/index.css";
import { Box } from "@chakra-ui/react";

type Props = {
  images: string[];
};

const Carousel = ({ images }: Props) => {
  const swiperRef = useRef<SwipeRef>(null);
  const [index, setIndex] = useState<any>();

  const swipeTo = () => {
    const swiperInstance = swiperRef.current;
    const currPage: string = index * 1 + "";
    swiperInstance?.swipeTo(parseInt(currPage, 10));
  };

  const prev = () => {
    const swiperInstance = swiperRef.current;
    swiperInstance?.prev();
  };

  const next = () => {
    const swiperInstance = swiperRef.current;
    swiperInstance?.next();
  };

  const onChange = (currPage: number, prevPage: number) => {
    console.log(currPage, prevPage);
  };

  return (
    <Box w="100%">
      {/* <div style={{ marginBottom: 20 }}>
        <div className="manu-action">
          <input
            type="number"
            value={index}
            onChange={(e) => setIndex(e.target.value)}
          />
          <span className="btn" onClick={swipeTo}>
            手动跳转页面(从零开始)
          </span>
        </div>
        <div className="more-action">
          <span className="btn" onClick={prev}>
            上一页
          </span>
          <span className="btn" onClick={next}>
            下一页
          </span>
        </div>
      </div> */}
      <Swiper
        autoPlay={3000} //自动切换间隔时间(ms)
        duration={1000} //切换动画持续时间(ms)
        selectedIndex={0}
        showIndicators={true}
        indicator={null} //两侧翻页按钮
        dots={null}  //底部dots
        showDots={false} //是否显示底部dots
        direction="horizontal" 
        loop={true}
        ref={swiperRef}
        // onChange={onChange}
      >
        {images.map((item: string, key) => (
          <div key={key}>
            <img src={item} style={{width: "100%"}} />
          </div>
        ))}
      </Swiper>
    </Box>
  );
};

export default Carousel;
